import { jsx as _jsx } from "react/jsx-runtime";
import { Redirect } from "react-router-dom";
import { standardCheckoutRoutes, trialCheckoutRoutes } from "@jti/fe-common";
import { CartPage } from "../../pages/CartPage";
import { DeliveryPage } from "../../pages/DeliveryPage";
import { OrderSummaryPage } from "../../pages/OrderSummaryPage";
import { Page404 } from "../../pages/Page404";
import { PaymentPage } from "../../pages/PaymentPage";
import { ShippingPage } from "../../pages/ShippingPage";
// TODO: Should be removed DESP-83761
export const LEGACY_routes = [
    {
        path: ["/checkout"],
        exact: true,
        render: () => _jsx(Redirect, { to: standardCheckoutRoutes.shipping }),
    },
    {
        path: ["/checkout/:orderId", "/trial/checkout/:orderId"],
        exact: true,
        render: ({ match }) => {
            const { orderId } = match.params;
            return _jsx(Redirect, { to: standardCheckoutRoutes.payment.getBaseUrl(orderId) });
        },
    },
    {
        path: [
            "/checkout/:orderId/:paymentToken/pay/successful",
            "/checkout/:orderId/thank-you",
            "/trial/checkout/:orderId/:paymentToken/pay/successful",
        ],
        exact: true,
        render: ({ match }) => {
            const { orderId, paymentToken } = match.params;
            return _jsx(Redirect, { to: standardCheckoutRoutes.payment.getSuccessPaymentUrl(orderId, paymentToken) });
        },
    },
    {
        path: ["/checkout/:orderId/payment-failed", "/trial/checkout/:orderId/payment-failed"],
        exact: true,
        render: ({ match }) => {
            const { orderId } = match.params;
            return _jsx(Redirect, { to: standardCheckoutRoutes.payment.getFailedPaymentUrl(orderId) });
        },
    },
];
export const routes = [
    ...LEGACY_routes,
    {
        path: standardCheckoutRoutes.root,
        exact: true,
        component: CartPage,
    },
    {
        path: [standardCheckoutRoutes.shipping, trialCheckoutRoutes.shipping],
        exact: true,
        component: ShippingPage,
    },
    {
        path: [standardCheckoutRoutes.delivery, trialCheckoutRoutes.delivery],
        exact: true,
        component: DeliveryPage,
    },
    {
        path: [
            standardCheckoutRoutes.payment.basePath,
            trialCheckoutRoutes.payment.basePath,
            standardCheckoutRoutes.payment.failedPaymentPath,
            trialCheckoutRoutes.payment.failedPaymentPath,
        ],
        exact: true,
        component: PaymentPage,
    },
    {
        path: [
            standardCheckoutRoutes.payment.successPaymentPath,
            trialCheckoutRoutes.payment.successPaymentPath,
            standardCheckoutRoutes.order.summaryPath,
            trialCheckoutRoutes.order.summaryPath,
        ],
        exact: true,
        component: OrderSummaryPage,
    },
    {
        path: "*",
        component: Page404,
    },
];
//# sourceMappingURL=routes.js.map